import React from "react";
import { GeneralIllustration, YesNo } from "@dreamhub/designsystem/icons";
import { ContractsWorkflowType } from "./types";

export const getOnboardingWorkflowTypeLabel = (
  type: number,
  t: (key: string) => string
): string => {
  switch (type) {
    case ContractsWorkflowType.GENERAL:
      return t("workflows.types.general");
    case ContractsWorkflowType.YES_NO_QUESTIONNAIRE:
      return t("workflows.types.yesNoQuestionnaire");
    case ContractsWorkflowType.CHECKLIST:
      return t("workflows.types.checklist");
    default:
      return t("workflows.types.general");
  }
};

export const getOnboardingWorkflowBadgeClass = (type: number): string => {
  switch (type) {
    case ContractsWorkflowType.GENERAL:
      return "bg-teal-opacity border-teal-500 px-[6px] py-1";
    case ContractsWorkflowType.YES_NO_QUESTIONNAIRE:
      return "bg-surface-tags-blue border-border-tags-blue px-[6px] py-1";
    case ContractsWorkflowType.CHECKLIST:
      return "bg-surface-tags-purple border-border-tags-purple px-[6px] py-1";
    default:
      return "bg-surface-tags-blue border-border-tags-blue px-[6px] py-1";
  }
};

export const getOnboardingWorkflowIcon = (type: number): React.ReactNode => {
  switch (type) {
    case ContractsWorkflowType.YES_NO_QUESTIONNAIRE:
      return React.createElement(YesNo);
    case ContractsWorkflowType.GENERAL:
    case ContractsWorkflowType.CHECKLIST:
    default:
      return React.createElement(GeneralIllustration);
  }
};
